// extracted by mini-css-extract-plugin
module.exports = {"root":"BannerContent_root__35Sue","iconHolder":"BannerContent_iconHolder__J9wDO","textHolder":"BannerContent_textHolder__3fTsY"};